import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private toasts: any[] = [];

  add(toast: any) {
    // add toast to array of active toasts
    this.toasts.push(toast);
  }

  remove(id: string) {
    // remove toast from array of active toasts
    this.toasts = this.toasts.filter(x => x.id !== id);
  }

  open(id: string) {
    // open toast specified by id
    const x = document.getElementById(id)!;

    // Add the "show" class to DIV
    x.className = "show";

    // After 3 seconds, remove the show class from DIV
    setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
    
  }

  close(id: string) {
    // close toast specified by id
    const toast = this.toasts.find(x => x.id === id);
    toast.close();
  }
}
